import {config} from '../config';

export default {
    getIsAmplitudeEnabled: () => config.data.tracking.isAmplitudeEnabled,
    getIsGAEnabled: () => config.data.tracking.isGAEnabled,
};
